<template>
  <div class="page">
    <template v-if="data.state == 0 || data.state == -1 || editing">
      <template v-if="!submited">
        <div class="w400">
          <a-steps :current="currentStep">
            <a-step title="基本信息"></a-step>
            <a-step title="项目详情"></a-step>
          </a-steps>
        </div>
        <transition name="slide-fade" mode="out-in">
          <template v-if="currentStep == 0">
            <div class="w1000 v-mt-lg">
              <div class="panel">
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                    <a-form-model-item :colon="false" v-if="data.state == -1">
                      <span slot="label"></span>
                      <a-alert class="v-mb-sm no-border" type="error">
                        <div slot="message">
                          <div class="font-md text-darkblue flex items-center">
                            <a-icon type="alert" class="v-mr-xs" />
                            此筹款申请已被驳回
                          </div>
                          <div class="flex v-mt-xs">
                            <span class="text-right text-grey">审核意见：</span>
                            <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                          </div>
                        </div>
                      </a-alert>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目类型
                      </span>
                      <a-radio-group v-model="form.prjType">
                        <a-radio :value="1">普通项目</a-radio>
                        <a-radio :value="2">一帮一（用户与受助人一对一资助）</a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目名称
                      </span>
                      <a-input v-model="form.prjName" ref="prjName" placeholder="请填写项目名称" style="width: 100%" />
                    </a-form-model-item>
                    <a-row>
                      <a-col span="12">
                        <a-form-model-item :colon="false" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            公开募捐备案编号
                          </span>
                          <a-input disabled v-model="form.raiseNo" ref="raiseNo" placeholder="公开募捐备案编号" style="width: 300px" />
                          <div class="ant-form-explain text-grey">慈善中国网站上的“公开募捐备案编号”</div>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            募捐备案编号有效期
                          </span>
                          <a-date-picker v-model="form.raiseExpireDate" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 140px" ref="raiseExpireDate" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目分类
                      </span>
                      <a-radio-group v-model="form.prjMainType" button-style="solid">
                        <a-radio-button :value="item.name" v-for="item in prjTypes" :key="item.name">{{ item.name }}</a-radio-button>
                      </a-radio-group>
                      <a-divider style="margin: 4px 0"></a-divider>
                      <a-radio-group v-model="form.prjSubType" button-style="solid">
                        <a-radio-button :value="item" v-for="item in subTypes" :key="item.name">{{ item }}</a-radio-button>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        受助对象
                      </span>
                      <!-- <a-select mode="multiple" v-model="form.targets" ref="targets" placeholder="根据项目实际帮扶人群选择" style="width: 100%">
                        <a-select-option value="失亲孤儿">失亲孤儿</a-select-option>
                        <a-select-option value="事实孤儿">事实孤儿</a-select-option>
                        <a-select-option value="困境儿童">困境儿童</a-select-option>
                        <a-select-option value="留守儿童">留守儿童</a-select-option>
                        <a-select-option value="乡村儿童">乡村儿童</a-select-option>
                        <a-select-option value="疾病儿童">疾病儿童</a-select-option>
                        <a-select-option value="女童">女童</a-select-option>
                        <a-select-option value="残障儿童">残障儿童</a-select-option>
                        <a-select-option value="寒门学子">寒门学子</a-select-option>
                        <a-select-option value="独居老人">独居老人</a-select-option>
                        <a-select-option value="抗战老兵">抗战老兵</a-select-option>
                        <a-select-option value="失能老人">失能老人</a-select-option>
                        <a-select-option value="患病老人">患病老人</a-select-option>
                        <a-select-option value="困境老人">困境老人</a-select-option>
                        <a-select-option value="困境女性">困境女性</a-select-option>
                        <a-select-option value="乡村女性">乡村女性</a-select-option>
                        <a-select-option value="创业女性">创业女性</a-select-option>
                        <a-select-option value="独抚妈妈">独抚妈妈</a-select-option>
                        <a-select-option value="流浪动物">流浪动物</a-select-option>
                        <a-select-option value="野生动物">野生动物</a-select-option>
                        <a-select-option value="濒危动物">濒危动物</a-select-option>
                        <a-select-option value="困境家庭">困境家庭</a-select-option>
                        <a-select-option value="农民兄弟">农民兄弟</a-select-option>
                        <a-select-option value="少数民族">少数民族</a-select-option>
                        <a-select-option value="社会工作者">社会工作者</a-select-option>
                        <a-select-option value="残障人士">残障人士</a-select-option>
                        <a-select-option value="受灾民众">受灾民众</a-select-option>
                        <a-select-option value="志愿者">志愿者</a-select-option>
                        <a-select-option value="社区收益">社区收益</a-select-option>
                        <a-select-option value="行业发展">行业发展</a-select-option>
                        <a-select-option value="病患群体">病患群体</a-select-option>
                        <a-select-option value="自然环境">自然环境</a-select-option>
                      </a-select> -->
                      <a-checkbox-group class="v-mt-sm" v-model="form.targets">
                        <a-row :gutter="[6, 6]">
                          <a-col :span="6"><a-checkbox value="失亲孤儿">失亲孤儿</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="事实孤儿">事实孤儿</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="困境儿童">困境儿童</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="留守儿童">留守儿童</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="乡村儿童">乡村儿童</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="疾病儿童">疾病儿童</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="女童">女童</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="残障儿童">残障儿童</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="寒门学子">寒门学子</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="独居老人">独居老人</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="抗战老兵">抗战老兵</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="失能老人">失能老人</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="患病老人">患病老人</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="困境老人">困境老人</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="困境女性">困境女性</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="乡村女性">乡村女性</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="创业女性">创业女性</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="独抚妈妈">独抚妈妈</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="流浪动物">流浪动物</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="野生动物">野生动物</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="濒危动物">濒危动物</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="困境家庭">困境家庭</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="农民兄弟">农民兄弟</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="少数民族">少数民族</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="社会工作者">社会工作者</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="残障人士">残障人士</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="受灾民众">受灾民众</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="志愿者">志愿者</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="社区收益">社区收益</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="行业发展">行业发展</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="病患群体">病患群体</a-checkbox></a-col>
                          <a-col :span="6"><a-checkbox value="自然环境">自然环境</a-checkbox></a-col>
                        </a-row>
                      </a-checkbox-group>
                    </a-form-model-item>
                    <a-form-model-item class="form-item-label-vtop" :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        授权函
                      </span>
                      <a-upload-dragger
                        class="upload-doc"
                        :action="`${baseURL}/file/upload`"
                        :data="{
                          params: JSON.stringify({ projectId, raiseId, fileType: 501, fileSign: 'PR' }),
                        }"
                        :show-upload-list="{
                          showPreviewIcon: true,
                          showRemoveIcon: true,
                          showDownloadIcon: true,
                        }"
                        :file-list="privacyFiles"
                        :before-upload="beforeUploadFile"
                        :class="{ 'upload-hideonuploaded': privacyFiles.length > 0 }"
                        @preview="handlePreviewFile"
                        @change="info => handleUploadChange(info, 1, 'privacyFiles')"
                        @download="({ fileId, name }) => downloadFile({ fileId, belongId: raiseId, fileSign: 'PR', fileName: name })"
                        accept=".pdf, .doc, .docx"
                        ref="privacyFiles"
                      >
                        <div class="v-pa-xs" v-if="privacyFiles.length === 0">
                          <a-icon type="plus" />
                          <p class="font-xs">点击或拖拽文件至此区域上传</p>
                        </div>
                      </a-upload-dragger>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        执行地点
                      </span>
                      <a-cascader change-on-select style="width: 300px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="请根据实际帮扶地区选择执行地点" v-model="form.districts" ref="districts" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        募捐类型
                      </span>
                      <a-radio-group v-model="form.raiseType">
                        <a-radio :value="1">短期</a-radio>
                        <a-radio :value="2">长期</a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目有效时间
                      </span>
                      <a-date-picker v-model="form.expireDate" value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 140px" ref="expireDate" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        年度筹款金额
                      </span>
                      <!-- <a-input-number class="no-handler" placeholder="输入筹款金额" v-model="form.raiseAmount" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" :min="0" ref="raiseAmount" style="width: 300px" /> 元 -->
                      <div class="input-wrapper">
                        <a-input-number v-model="form.raiseAmount" ref="raiseAmount" style="width: 300px" placeholder="输入筹款金额" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear />
                        <span class="input-unit">元</span>
                      </div>
                    </a-form-model-item>
                  </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="swap-right" type="primary" @click="handleNextStep">下一步，填写项目信息</a-button>
                  <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
                  <a-button icon="undo" type="indigo" @click="handleReset" v-else>重置</a-button>
                </a-space>
              </div>
            </div>
          </template>
          <template v-else-if="currentStep == 1">
            <div class="w1100 v-mt-lg">
              <div class="panel">
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                    <a-form-model-item :colon="false" v-if="data.state == -1">
                      <span slot="label"></span>
                      <a-alert class="v-mb-sm no-border" type="error">
                        <div slot="message">
                          <div class="font-md text-darkblue flex items-center">
                            <a-icon type="alert" class="v-mr-xs" />
                            此筹款申请已被驳回
                          </div>
                          <div class="flex v-mt-xs">
                            <span class="text-right text-grey">审核意见：</span>
                            <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                          </div>
                        </div>
                      </a-alert>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        首页推荐位项目副标题
                      </span>
                      <a-input v-model="form.subTitle" ref="subTitle" placeholder="输入项目副标题" style="width: 100%" />
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">提炼项目概要，不超过11个中文字符</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        搜索列表页/专题页头图
                      </span>
                      <a-upload
                        :action="`${baseURL}/file/upload`"
                        :data="{
                          params: JSON.stringify({ projectId, raiseId, fileType: 502, fileSign: 'PR' }),
                        }"
                        :file-list="mainFiles"
                        :before-upload="beforeUploadFile"
                        @preview="handlePreviewFile"
                        @change="info => handleUploadChange(info, 1, 'mainFiles')"
                        list-type="picture-card"
                        class="picture-uploader picture-uploader-zt"
                        accept=".png, .jpg, .jpeg"
                        ref="mainFiles"
                      >
                        <div v-if="mainFiles.length === 0">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">上传图片</div>
                        </div>
                      </a-upload>
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">有图片使用权，图片清晰、能打动人，且紧扣主题；jpg/png格式，图片尺寸700x516，大小不超过500kb</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        新版本项目顶部图片/视频展示区
                      </span>
                      <a-upload
                        :action="`${baseURL}/file/upload`"
                        :data="{
                          params: JSON.stringify({ projectId, raiseId, fileType: 503, fileSign: 'PR' }),
                        }"
                        :file-list="topFiles"
                        :before-upload="beforeUploadFile"
                        @preview="handlePreviewFile"
                        @change="info => handleUploadChange(info, 9, 'topFiles')"
                        list-type="picture-card"
                        class="picture-uploader picture-uploader-zt2"
                        accept=".png, .jpg, .jpeg, .avi,.mp4,.mov,.mkv,.rm,.rmvb,.flv,.wmv,.3gp"
                        ref="topFiles"
                      >
                        <div v-if="topFiles.length < 9">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">上传图片或视频</div>
                        </div>
                      </a-upload>
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">上传1-9张图片或视频，图片至少1张，视频仅限1个，上传图片或视频需有使用权</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">直播链接</span>
                      <a-input v-model="form.liveUrl" ref="liveUrl" placeholder="直播链接" style="width: 100%" />
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">请输入在支付宝平台直播的链接地址</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目简介
                      </span>
                      <a-textarea :auto-size="{ minRows: 3 }" v-model="form.summary" ref="summary" placeholder="项目简介" :rows="2" style="width: 100%" />
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">25至60字，围绕项目主旨填写，与项目标题相呼应，语言有感染力</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">项目线下首次执行时间</span>
                      <a-date-picker v-model="form.executeDate" value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 140px" ref="executeDate" />
                      <a-upload-dragger
                        class="upload-doc"
                        :action="`${baseURL}/file/upload`"
                        :data="{
                          params: JSON.stringify({ projectId, raiseId, fileType: 504, fileSign: 'PR' }),
                        }"
                        :show-upload-list="{
                          showPreviewIcon: true,
                          showRemoveIcon: true,
                          showDownloadIcon: true,
                        }"
                        :file-list="executeFiles"
                        :before-upload="beforeUploadFile"
                        :class="{ 'upload-hideonuploaded': executeFiles.length > 0 }"
                        @preview="handlePreviewFile"
                        @change="info => handleUploadChange(info, 1, 'executeFiles')"
                        @download="({ fileId, name }) => downloadFile({ fileId, belongId: raiseId, fileSign: 'PR', fileName: name })"
                        accept=".pdf, .doc, .docx, .jpg, .png, .jpeg"
                        ref="executeFiles"
                      >
                        <div class="v-pa-xs" v-if="executeFiles.length === 0">
                          <a-icon type="plus" />
                          <p class="font-xs">点击或拖拽文件至此区域上传</p>
                        </div>
                      </a-upload-dragger>
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">上传项目线下执行证明材料，如项目立项报告、调研报告、历年执行报告</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">项目获奖情况</span>
                      <a-input v-model="form.rewards" ref="rewards" placeholder="请输入【年份-最高荣誉奖项名称】，最多15个中文" style="width: 100%" />
                      <a-upload-dragger
                        class="upload-doc"
                        :action="`${baseURL}/file/upload`"
                        :data="{
                          params: JSON.stringify({ projectId, raiseId, fileType: 505, fileSign: 'PR' }),
                        }"
                        :show-upload-list="{
                          showPreviewIcon: true,
                          showRemoveIcon: true,
                          showDownloadIcon: true,
                        }"
                        :file-list="rewardFiles"
                        :before-upload="beforeUploadFile"
                        :class="{ 'upload-hideonuploaded': rewardFiles.length > 0 }"
                        @preview="handlePreviewFile"
                        @change="info => handleUploadChange(info, 1, 'rewardFiles')"
                        @download="({ fileId, name }) => downloadFile({ fileId, belongId: raiseId, fileSign: 'PR', fileName: name })"
                        accept=".pdf, .doc, .docx, .jpg, .png, .jpeg"
                        ref="rewardFiles"
                      >
                        <div class="v-pa-xs" v-if="rewardFiles.length === 0">
                          <a-icon type="plus" />
                          <p class="font-xs">点击或拖拽文件至此区域上传</p>
                        </div>
                      </a-upload-dragger>
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">上传获奖证明</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目详情
                      </span>
                      <tinymce id="myedit" ref="editor" v-model="form.content" :file-params="{ projectId, raiseId, fileType: 208, fileSign: 'PR' }" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目执行计划
                      </span>
                      <tinymce id="myedit" ref="editor" v-model="form.plan" :file-params="{ projectId, raiseId, fileType: 208, fileSign: 'PR' }" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目预算
                      </span>
                      <tinymce id="myedit" ref="editor" v-model="form.budgets" :file-params="{ projectId, raiseId, fileType: 208, fileSign: 'PR' }" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        剩余财产处置
                      </span>
                      <a-textarea :auto-size="{ minRows: 3 }" v-model="form.remains" ref="remains" placeholder="50字简要介绍公益项目，会显示在项目详情页的开头" :rows="2" style="width: 100%" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目执行方式
                      </span>
                      <a-radio-group v-model="form.orgType">
                        <a-radio :value="1">本机构执行</a-radio>
                        <a-radio :value="2">其他机构执行</a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                    <template v-if="form.orgType == 2">
                      <a-form-model-item :colon="false">
                        <span slot="label">
                          <i class="required-mark">*</i>
                          执行机构名称
                        </span>
                        <a-input v-model="form.orgName" ref="orgName" placeholder="机构名称" style="width: 100%" />
                      </a-form-model-item>
                      <a-form-model-item :colon="false">
                        <span slot="label">
                          <i class="required-mark">*</i>
                          执行机构简介
                        </span>
                        <a-textarea :auto-size="{ minRows: 3 }" v-model="form.orgDesc" ref="orgDesc" placeholder="机构简介" :rows="2" style="width: 100%" />
                      </a-form-model-item>
                    </template>
                    <!-- <a-form-model-item :colon="false">
                      <span slot="label">捐赠票据说明</span>
                      <a-textarea :auto-size="{ minRows: 3 }" v-model="form.summary" ref="summary" placeholder="50字简要介绍公益项目，会显示在项目详情页的开头" :rows="2" style="width: 100%" />
                    </a-form-model-item> -->
                  </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="swap-left" type="indigo" @click="currentStep = 0">返回上一步</a-button>
                  <a-button icon="check" type="primary" @click="handleConfirm" :loading="saving">提交筹款申请信息</a-button>
                  <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
                  <!-- <a-button icon="undo" type="indigo" @click="handleReset">重置</a-button> -->
                </a-space>
              </div>
            </div>
          </template>
        </transition>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的筹款申请信息已提交，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="load">查看已提交信息</a-button>
          </template>
        </a-result>
      </template>
    </template>
    <template v-else-if="[1, 2, 3].includes(data.state)">
      <div class="w960 v-mt-lg">
        <div class="panel">
          <div class="panel-body">
            <a-alert banner :show-icon="false" class="v-mb-sm" type="warning" v-if="data.state == 1">
              <div slot="message" class="text-grey">此筹款申请于 {{ data.applyTime }} 提交，<a-button icon="form" type="indigo" size="small" @click="onEdit">重新编辑</a-button></div>
            </a-alert>
            <table class="table table-plain table-fixed">
              <tbody>
                <tr>
                  <td colspan="4" class="text-indigo">基础信息</td>
                </tr>
                <tr>
                  <th width="180">项目名称</th>
                  <td width="35%">{{ form.prjName }}</td>
                  <th width="120">项目类型</th>
                  <td>
                    <template v-if="form.prjType == 1">普通项目</template>
                    <template v-else-if="form.prjType == 2">一帮一（用户与受助人一对一资助）</template>
                  </td>
                </tr>
                <tr>
                  <th>公开募捐备案编号</th>
                  <td>{{ form.raiseNo }}</td>
                  <th>募捐备案编号有效期</th>
                  <td>{{ form.raiseExpireDate }}</td>
                </tr>
                <tr>
                  <th>项目分类</th>
                  <td colspan="3">{{ form.prjMainType }} — {{ form.prjSubType }}</td>
                </tr>
                <tr>
                  <th>受助对象</th>
                  <td colspan="3">{{ form.targets ? form.targets.join('、') : '' }}</td>
                </tr>
                <tr>
                  <th valign="top">授权函</th>
                  <td colspan="3">
                    <file-container :img-size="[220, 120]" :files="data.privacyFiles" :belongId="raiseId" fileSign="PR" v-if="data.privacyFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th>执行地点</th>
                  <td>{{ form.districts ? form.districts.join('') : '' }}</td>
                  <th>募捐类型</th>
                  <td>
                    <template v-if="form.raiseType == 1">短期</template>
                    <template v-else-if="form.raiseType == 2">长期</template>
                  </td>
                </tr>
                <tr>
                  <th>项目有效时间</th>
                  <td>{{ form.expireDate }}</td>
                  <th>年度筹款金额</th>
                  <td>{{ $utils.thousands(form.raiseAmount) }} 元</td>
                </tr>
                <tr>
                  <td colspan="4" class="text-indigo">筹款信息</td>
                </tr>
                <tr>
                  <th>首页推荐位项目副标题</th>
                  <td colspan="3">{{ form.subTitle }}</td>
                </tr>
                <tr>
                  <th>搜索列表页/专题页头图</th>
                  <td colspan="3">
                    <file-container :img-size="[200, 120]" :files="data.mainFiles" :belongId="raiseId" fileSign="PR" v-if="data.mainFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th>顶部图片/视频展示区</th>
                  <td colspan="3">
                    <file-container :img-size="[200, 120]" :files="data.topFiles" :belongId="raiseId" fileSign="PR" v-if="data.topFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th>直播链接</th>
                  <td colspan="3">{{ form.liveUrl }}</td>
                </tr>
                <tr>
                  <th valign="top">项目简介</th>
                  <td colspan="3" v-html="$utils.convertToHtml(form.summary)"></td>
                </tr>
                <tr>
                  <th valign="top">项目线下首次执行时间</th>
                  <td colspan="3">
                    <div :class="{ 'v-mb-sm' : form.executeDate }">{{ form.executeDate }}</div>
                    <template v-if="data.executeFiles && data.executeFiles.length">
                      <div class="text-italic v-mb-xs text-brown"><a-icon type="paper-clip" />附件：</div>
                      <file-container :img-size="[200, 120]" :files="data.executeFiles" :belongId="raiseId" fileSign="PR" v-if="data.executeFiles && raiseId"></file-container>
                    </template>
                  </td>
                </tr>
                <tr>
                  <th valign="top">项目获奖情况</th>
                  <td colspan="3">
                    <div :class="{ 'v-mb-sm' : form.rewards }">{{ form.rewards }}</div>
                    <template v-if="data.rewardFiles && data.rewardFiles.length">
                      <div class="text-italic v-mb-xs text-brown"><a-icon type="paper-clip" />附件：</div>
                      <file-container :img-size="[200, 120]" :files="data.rewardFiles" :belongId="raiseId" fileSign="PR" v-if="data.rewardFiles && raiseId"></file-container>
                    </template>
                  </td>
                </tr>
                <tr>
                  <th valign="top">项目详情</th>
                  <td colspan="3" v-html="form.content"></td>
                </tr>
                <tr>
                  <th valign="top">项目执行计划</th>
                  <td colspan="3" v-html="form.plan"></td>
                </tr>
                <tr>
                  <th valign="top">项目预算</th>
                  <td colspan="3" v-html="form.budgets"></td>
                </tr>
                <tr>
                  <th valign="top">剩余财产处置</th>
                  <td colspan="3" v-html="form.remains"></td>
                </tr>
                <tr>
                  <th>项目执行方式</th>
                  <td colspan="3">
                    <template v-if="form.orgType == 1">本机构执行</template>
                    <template v-else-if="form.orgType == 2">其他机构执行</template>
                  </td>
                </tr>
                <template v-if="form.orgType == 2">
                  <tr>
                    <th>执行机构名称</th>
                    <td colspan="3">{{ form.orgName }}</td>
                  </tr>
                  <tr>
                    <th>执行机构简介</th>
                    <td colspan="3">{{ form.orgDesc }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import alldistricts from '@/utils/districts'
import tinymce from '@/components/tinymce'
import { submitRaise, getRaise } from '@/api/project/funded'
const prjTypes = [
  { name: '乡村振兴', children: ['留守人群', '硬件设施', '社区发展', '产业扶持'] },
  { name: '扶危助困', children: ['物资帮扶', '灾害救援', '灾后重建', '医疗救助', '医疗服务', '女性服务', '助老服务', '特殊人群', '残障关怀'] },
  { name: '生态人文', children: ['动物保护', '生态系统', '气候变化', '污染防治', '自然教育', '绿色社区', '传统文化', '文物保护', '社会创新'] },
  { name: '教育助学', children: ['助学救济', '素质教育', '特殊儿童', '师资支持', '设施建设', '心里教育', '健康成长'] },
]

const form = {
  // 基本信息
  prjType: 1,
  prjName: '',
  raiseNo: '',
  raiseExpireDate: undefined,
  prjMainType: prjTypes[0].name,
  prjSubType: undefined,
  targets: [],
  districts: [],
  raiseType: 2,
  expireDate: undefined,
  raiseAmount: undefined,
  // 项目详情
  subTitle: '',
  liveUrl: '',
  summary: '',
  executeDate: undefined,
  rewards: '',
  content: '',
  plan: '',
  budgets: '',
  remains: '',
  orgType: 2,
  orgName: '',
  orgDesc: '',
}
export default {
  props: {
    raiseId: {
      type: Number,
      required: true,
    },
    raiseNo: {
      type: String,
    },
  },
  components: {
    tinymce,
  },
  data() {
    return {
      projectId: undefined,
      // raiseId: null,
      currentStep: 0,
      submited: false,
      editing: false,
      saving: false,
      data: {},
      districts: alldistricts,
      form: {
        ...form,
      },
      prjTypes,
      privacyFiles: [],
      mainFiles: [],
      topFiles: [],
      executeFiles: [],
      rewardFiles: [],
      planFiles: [],
      serviceFiles: [],
      
    }
  },
  computed: {
    subTypes: vm => prjTypes.find(d => d.name === vm.form.prjMainType).children,
  },
  methods: {
    load() {
      this.loading = true
      this.editing = false
      getRaise(this.raiseId).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { projectId, raiseInfo, raiseNo, files } = result
          this.form = { ...form, ...JSON.parse(raiseInfo || '{}') }
          if (raiseNo) {
            this.form.raiseNo = raiseNo
          }
          result.privacyFiles = files.filter(file => file.fileType === 501)
          result.mainFiles = files.filter(file => file.fileType === 502)
          result.topFiles = files.filter(file => file.fileType === 503)
          result.executeFiles = files.filter(file => file.fileType === 504)
          result.rewardFiles = files.filter(file => file.fileType === 505)
          this.data = result
          this.projectId = projectId
          this.privacyFiles = result.privacyFiles
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.mainFiles = result.mainFiles
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.topFiles = result.topFiles
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.executeFiles = result.executeFiles
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.rewardFiles = result.rewardFiles
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.submited = false
        }
      })
    },
    handleNextStep() {
      let { prjName, raiseExpireDate, prjSubType, targets, districts, expireDate, raiseAmount} = this.form
      let { privacyFiles } = this
      this.$message.destroy()
      if (prjName.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.prjName.focus()
        return
      }
      if (!raiseExpireDate) {
        this.$message.warning('请选择备案编号有效期')
        this.$refs.raiseExpireDate.focus()
        return
      }
      if (!prjSubType) {
        this.$message.warning('请选择项目分类')
        return
      }
      if (!targets) {
        this.$message.warning('请选择受助对象')
        this.$refs.targets.focus()
        return
      }
      if (privacyFiles.length === 0) {
        this.$message.warning('请上传授权函')
        this.$refs.privacyFiles.$el.classList.add('uploader-empty')
        return
      }
      if (districts.length === 0) {
        this.$message.warning('请选择执行地点')
        this.$refs.districts.focus()
        return
      }
      if (!expireDate) {
        this.$message.warning('请选择项目有效时间')
        this.$refs.expireDate.focus()
        return
      }
      if (!raiseAmount) {
        this.$message.warning('请输入年度筹款金额')
        this.$refs.raiseAmount.focus()
        return
      }
      this.currentStep += 1
    },
    handleConfirm() {
      let { subTitle, summary, content, plan, budgets, remains, orgType, orgName, orgDesc } = this.form
      let { mainFiles, topFiles } = this
      this.$message.destroy()
      if (subTitle.trim() === '') {
        this.$message.warning('请输入项目副标题')
        this.$refs.subTitle.focus()
        return
      }
      if (mainFiles.length === 0) {
        this.$message.warning('请上传搜索列表页/专题页头图')
        this.$refs.mainFiles.$el.classList.add('uploader-empty')
        return
      }
      if (topFiles.length === 0) {
        this.$message.warning('请上传顶部图片/视频')
        this.$refs.topFiles.$el.classList.add('uploader-empty')
        return
      }
      if (summary.trim() === '') {
        this.$message.warning('请输入项目简介')
        this.$refs.summary.focus()
        return
      }
      if (content.trim() === '') {
        this.$message.warning('请输入项目详情')
        return
      }
      if (plan.trim() === '') {
        this.$message.warning('请输入项目执行计划')
        return
      }
      if (budgets.trim() === '') {
        this.$message.warning('请输入项目预算')
        return
      }
      if (remains.trim() === '') {
        this.$message.warning('请输入剩余财产处置')
        this.$refs.remains.focus()
        return
      }
      if (orgType === 2) {
        if (orgName.trim() === '') {
          this.$message.warning('请输入执行机构')
          this.$refs.orgName.focus()
          return
        }
        if (orgDesc.trim() === '') {
          this.$message.warning('请输入执行机构简介')
          this.$refs.orgDesc.focus()
          return
        }
      }
      this.$confirm({
        title: '确认提交筹款申请信息？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.saving = true
      let { mainFiles, topFiles, executeFiles, rewardFiles, privacyFiles } = this
      let files = mainFiles
        .map(({ fileId }) => ({ fileId }))
        .concat(topFiles.map(({ fileId }) => ({ fileId })))
        .concat(executeFiles.map(({ fileId }) => ({ fileId })))
        .concat(rewardFiles.map(({ fileId }) => ({ fileId })))
        .concat(privacyFiles.map(({ fileId }) => ({ fileId })))
      let params = {
        files,
        raiseId: this.raiseId,
        raiseInfo: JSON.stringify(this.form),
        projectId: this.projectId,
      }
      this.$message.destroy()
      submitRaise(params).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.submited = true
          this.$emit('submit')
        } else {
          this.$message.warning(data.msg)
        }
      })
    },
    handleReset() {},
    handleUploadChange(info, count, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
    onEdit() {
      this.currentStep = 0
      this.editing = true
    },
  },
  created() {
    this.load()
  },
}
</script>
